import { useContext, useEffect, useState } from "react"
import { getEvidenceData } from "../../../util/getEvidenceData";
import EmailSignatureService from "../../../services/EmailSignatureService";
import { useNavigate } from "react-router-dom";
import { BatchContext } from "../../../contexts/BatchContext";
import PendingDocumentService from "../../../services/PendingDocumentService";
import { FIRST_LOAD } from "../../../constants/GeneralConstants";
import { isFormDataMissingError } from "../../../util/signatureErrorUtils";
import { FormDataMissingModal } from "../../Modals/FormDataMissingModal/FormDataMissingModal";

export const SimplifiedSignature = ({ signerGuid, setLoadingMorePages, documents, emailId, email }) => {
    const navigate = useNavigate();
    const { remainingBatchDocuments, batchAttachedImages } = useContext(BatchContext);
    const [showFormDataMissingModal, setShowFormDataMissingModal] = useState(false);

    useEffect(() => {
        const sendSimplifiedSignature = async () => {
            const evidenceData = await getEvidenceData();

            const body = {
                SignatureImage: '',
                SignatureRawData: '',
                OTP: '',
                ...evidenceData,
            };

            if (documents.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages) {
                return navigate("/attach-images", {
                    state: {
                        documents,
                        emailId,
                        otpCode: null
                    }
                });
            }

        
            EmailSignatureService.sendSign(signerGuid, body)
                .then(() => {
                    setLoadingMorePages(false);
                    localStorage.setItem(FIRST_LOAD, "true");

                    if (remainingBatchDocuments > 0) {
                        navigate('/batch-success', {
                            state: {
                            emailId,
                            }
                        })
                        return;
                    }
                    
                    PendingDocumentService.getPendingDocumentsList(emailId)
                    .then(res => {
                        const pendingDocuments = res.data;
                        setLoadingMorePages(false);
                        navigate("/signature-success", {
                        state: {
                            pendingDocuments,
                            emailId,
                            email
                        }
                        });
                    })
                    .catch(err => {
                        setLoadingMorePages(false);
                        navigate("/signature-success", {
                            state: {
                                pendingDocuments: [],
                                emailId,
                                email
                            }
                        });
                    });
                })
                .catch(err => {
                    setLoadingMorePages(false);
                    if (isFormDataMissingError(err)) {
                        setShowFormDataMissingModal(true);
                        return;
                    }
                    console.log(err);
                });

            return;
        }

        sendSimplifiedSignature();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <FormDataMissingModal
                open={showFormDataMissingModal}
                onClose={() => setShowFormDataMissingModal(false)}
            />
        </>
    );
}